import { useSyncExternalStore } from 'react';
import { subscribeEditorInsert, getActiveEditorNoun } from '@/lib/editorInsertRegistry';

/**
 * Noun of the currently open editor ('document' | 'spreadsheet' |
 * 'presentation'), or null when no editor is open.
 *
 * Reads from the insert registry rather than the sidebar's type so the answer
 * always reflects a panel that is really mounted and able to receive content.
 * Native has no editor panels, so this stays null there.
 */
export default function useActiveEditorNoun() {
  return useSyncExternalStore(
    subscribeEditorInsert,
    getActiveEditorNoun,
    () => null,
  );
}
